module.exports = __webpack_public_path__ + "static/media/left.2a8524b2.png";